import React from 'react';
import AchievementSlider from './achievementSlider';
import connect from "~/tools/connect"
import profileStore from '~/redux/profile/store'
import userStore from '~/redux/user/store';
import {getAchievements} from "~/redux/profile/actions";
import Spinner from "~/components/Spinner";
import "./style.scss";

class AllAchievements extends React.Component {

	componentDidMount() {
        profileStore.dispatch(
            getAchievements(this.state.user.userId)
        );
    }

	render() {
		return (
			<div className="all-achievements">
				<div className="module-header">
					ACHIEVEMENTS
				</div>

				{this.state.achievements.loading && 
					<div className="neoProfileContainer">
	                    Loading... <Spinner/>
	                </div>
	            }

				{this.state.achievements.data && this.state.achievements.data.map( (ag) => {
					return (
						<AchievementSlider 
							key={ag.type}
							achievements={ag.completed}
							title={ag.type}>
						</AchievementSlider>
					);
				})}
			</div>
		);
	}

}

connect(AllAchievements, state => ({ user: state.user }), userStore);
connect(AllAchievements, state => ({ achievements: state.achievements}), profileStore);

export default AllAchievements;